// extracted by mini-css-extract-plugin
export default {"color-white":"#FFFFFF","colorWhite":"#FFFFFF","homepageLayout":"h18P2","homepageBrandValue":"_2YTym"};